import ApiGet from "../../../../../api-controller-mod/api-serv/get-api/getApi";
import ApiPatch from "../../../../../api-controller-mod/api-serv/post-api/patchApi";
import { MockSetGroup } from "../../../../../component-controller-mod/component-serv/list-fs-cp/media-list-op/ts/setting-list-tier.type";

export const MockSetAttachment: MockSetGroup[] = [
    {
        id: 1,
        title: "Attachment Size",
        description: "Configure maximum file size for attachments",
        items: [
            {
                id: 1,
                title: "Maximum attachment size (mb)",
                description: "Set the maximum file size for attachments across the platform",
                controlType: "input",
                inputConfig: { type: "text", width: 72, placeholder: "1 MB", validate: true },
            }
        ]
    }
]

export type AttachmentSettingsResponse = {
  success: boolean;
  requestId: string;
  data: {
    module: string;
    settings: {
      maxSizeMb: number;
      allowedMimeTypes: string;
    };
  };
};

export const getAttachmentSettings = () => ApiGet<AttachmentSettingsResponse>("/api/v1/settings/attachment");

export type AttachmentUpdateBody = {
  maxSizeMb?: number;
  // optionally later:
  // allowedMimeTypes?: string;
};

//  update endpoint if your backend uses different path
export const patchAttachmentSettings = (body: AttachmentUpdateBody) => ApiPatch("/api/v1/settings/attachment/update", body);